export const FINANCE_TRANSATIONS_GET_ALL = "FINANCE_TRANSATIONS_GET_ALL";

export const FINANCE_PRICING_MOVIE_ADDNEW = "FINANCE_PRICING_MOVIE_ADDNEW";
export const FINANCE_PRICING_MOVIE_UPDATE = "FINANCE_PRICING_MOVIE_UPDATE";
export const FINANCE_PRICING_GET_ALL = "FINANCE_PRICING_GET_ALL"
export const FINANCE_PRICING_MOVIE_DELETE = "FINANCE_PRICING_MOVIE_DELETE";

export const FINANCE_SETTLEMENT_DELETE = "FINANCE_SETTLEMENT_DELETE";
export const FINANCE_SETTLEMENT_ADDNEW = "FINANCE_SETTLEMENT_ADDNEW";
export const FINANCE_SETTLEMENT_UPDATE = "FINANCE_SETTLEMENT_UPDATE";
export const FINANCE_SETTLEMENT_GET_ALL = "FINANCE_SETTLEMENT_GET_ALL";

export const FINANCE_GET_BANK_BALANCE = "FINANCE_GET_BANK_BALANCE";